import { render } from "./DownloadGerenalInsurance.vue?vue&type=template&id=4956a068"
import script from "./DownloadGerenalInsurance.vue?vue&type=script&lang=js"
export * from "./DownloadGerenalInsurance.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__